import { apiRequest } from './http';
import type {
  ApiItemResponse,
  ApiListResponse,
  InboundAs2DocumentDetails,
  InboundAs2DocumentSummary,
  InboundDocumentListQuery,
} from '../types/api';

function queryString(query: InboundDocumentListQuery): string {
  const search = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.set(key, String(value));
    }
  });

  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

export async function listInboundDocuments(
  query: InboundDocumentListQuery,
): Promise<ApiListResponse<InboundAs2DocumentSummary>> {
  return apiRequest<ApiListResponse<InboundAs2DocumentSummary>>(`/as2/inbound-documents${queryString(query)}`);
}

export async function getInboundDocument(id: string): Promise<InboundAs2DocumentDetails> {
  const response = await apiRequest<ApiItemResponse<InboundAs2DocumentDetails>>(`/as2/inbound-documents/${id}`);
  return response.data;
}

export async function reprocessInboundDocument(id: string): Promise<{ documentId: string; processingStatus: string }> {
  const response = await apiRequest<ApiItemResponse<{ documentId: string; processingStatus: string }>>(
    `/as2/inbound-documents/${id}/reprocess`,
    { method: 'POST' },
  );
  return response.data;
}
